import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {debounce, isMobile} from "../../utils";

gsap.registerPlugin(ScrollTrigger);

class VerticalBioHorizontalScroll {
    constructor(parent) {
        this.parent = parent;
        this.prevWidth = window.innerWidth;
        this.cardWidth = 0;

        this.introEl = document.querySelector('.bh-intro .container');
        this.stickyEl = document.querySelector('.bh-horizontal-slider--sticky');
        this.stickyElWrapper = this.stickyEl.querySelector('.bh-slider-wrapper');
        this.swiperSlide = [...this.stickyEl.querySelectorAll('.slide')];
        this.header = document.getElementById('header');
        this.subheader = document.querySelector('.page-nav')
        this.body = document.querySelector('body');
        this.firstSlide = this.swiperSlide[0];
        this.firstSlideInner = this.firstSlide.querySelector('.heading--inner');

        this.initCalculateStickyBasedOnScreenHeight = this.initCalculateStickyBasedOnScreenHeight.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.initResizing = this.initResizing.bind(this);

        this.initCalculateStickyBasedOnScreenHeight();
        this.initResizing();
    }

    initCalculateStickyBasedOnScreenHeight() {
        this.wrapperWidth = this.stickyElWrapper.offsetWidth;
        let offsetHeader = 0;
        if(this.header) {
            offsetHeader = this.header.offsetHeight;
        }

        if(this.subheader) {
            offsetHeader += this.subheader.offsetHeight;
        }

        const sliderLeftPosition = this.introEl ? this.introEl.getBoundingClientRect().left + parseFloat(window.getComputedStyle(this.introEl).paddingLeft) : 0;
        gsap.set(this.firstSlideInner, { paddingLeft: sliderLeftPosition});

        this.cardWidth = this.swiperSlide[0].offsetWidth / 2;

        let offset = 0;
        if(this.stickyEl.offsetHeight < window.innerHeight) {
            offset = window.innerHeight - this.stickyEl.offsetHeight - (window.innerWidth > 767 ? 30 : 10) - (window.innerHeight - this.stickyEl.offsetHeight) / 2;
        } else {
            offset = window.innerHeight - this.stickyEl.offsetHeight - (window.innerWidth > 767 ? 30 : 10);
        }

        if(window.innerWidth > 1024 && window.innerHeight * .9 < this.stickyElWrapper.offsetHeight + offsetHeader) {
            offset -= (this.stickyElWrapper.offsetHeight - window.innerHeight) / 2;
        }

        this.stickyEl.style.top = offset + 'px';
        const centerOfScreen = window.innerWidth / 2;

        gsap.defaults({ overwrite: 'auto', });

        if(this.tl) {
            this.tl.scrollTrigger.kill();
            this.tl.kill();
        }

        const xDeltaCoefficient = isMobile() ? 1 : 2;

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.parent,
                start: `top-=${ offset * .9 } top`,
                end: 'bottom-=10% 100%',
                preventOverlaps: true,
                fastScrollEnd: false,
                scrub: 0.5,
                immediateRender: false,
                invalidateOnRefresh: true,
                markers: false,
            }
        })
            .to(this.swiperSlide, {
                x: `-=${(this.swiperSlide.length - xDeltaCoefficient) * (this.cardWidth * 2)}`,
                ease: "none",
                onUpdate: () => {
                    this.swiperSlide.forEach((slide, index) => {
                        const slideRect = slide.getBoundingClientRect();
                        const slideCenter = slideRect.left + slideRect.width / 2;
                        const distance = Math.abs(slideCenter - centerOfScreen);
                        if(distance < this.cardWidth) {
                            slide.classList.add('active');
                        } else if(slide.classList.contains('active')) {
                            slide.classList.remove('active');
                        }
                    });
                }
            });
    }

    handleResize() {
        if (this.prevWidth !== window.innerWidth || window.innerWidth > 767) {
            this.prevWidth = window.innerWidth;
            this.initCalculateStickyBasedOnScreenHeight();
            ScrollTrigger.refresh();
        }
    }

    initResizing() {
        window.addEventListener('resize', debounce(this.handleResize, 200));
    }
}

export default VerticalBioHorizontalScroll;
